import {calcUnitUpdateBasedOnPendingRecruitment} from "./calcUnitUpdateBasedOnPendingRecruitment";
import {filterArrivedRecruitmentActions} from "../../effects/abilityResultHolds";

/**
 * Размер отряда для показа в статах: докупленное на этапе найма применится к
 * отряду только в конце этапа. Счет тот же, что у бейджа «+N» на поле: докупка,
 * чей шар еще летит к отряду, пока не считается
 */
export const getUnitSizeWithPendingRecruitment = (unit, pendingRecruitmentActions) => (
  unit.size + calcUnitUpdateBasedOnPendingRecruitment(unit, filterArrivedRecruitmentActions(pendingRecruitmentActions))
);
